/* ==================================================================
   Descrição técnica sugerida: o texto que vai na ART
   ------------------------------------------------------------------
   É o texto que o Alan teria que escrever à mão no CreaNet, montado a
   partir do escopo que o morador marcou. Ele revisa e cola; não digita.

   Item 2b do contrato: o assistente deve "montar o pedido com os dados
   do cliente e a descrição técnica sugerida". Até 14/09/2026 as frases
   moravam só no `public/legacy.js`, e o texto ia apenas na mensagem de
   WhatsApp do atendimento manual: a ficha do pedido no painel mostrava
   o escopo em rótulos e nada mais. Achado na conferência de entrega.

   Por isso mudou para cá, a mesma casa do motor: o painel importa daqui
   no servidor, e o widget recebe pelo `public/motor.js` compilado
   (`AgenteMotor.descricaoTecnica`). Uma redação só, porque duas cópias
   divergem na primeira correção, e aí o morador vê um texto e o Alan
   cola outro.

   ⚠️ O texto sai sob o CREA do Alan. Mudar uma frase aqui é mudar o que
   a ART declara: combinar com ele antes.
   ================================================================== */

const FRASES: Record<string, string> = {
  piso:
    "remoção do revestimento existente, regularização de contrapiso e assentamento de novo revestimento cerâmico",
  pintura:
    "serviços de pintura, revestimento de gesso e instalação de mobiliário fixo, sem intervenção em elementos estruturais",
  ar:
    "instalação de sistema de climatização tipo split, com furação de fachada para passagem de tubulação frigorígena e dreno",
  vidro:
    "instalação de sistema de fechamento de sacada em vidro temperado com perfis de alumínio, sem alteração de fachada estrutural",
  parede:
    "demolição de alvenaria de vedação sem função estrutural, com fechamento e regularização das superfícies remanescentes",
  hidraulica:
    "remanejamento de pontos hidráulicos e de esgoto, com refazimento da impermeabilização das áreas molhadas afetadas",
  eletrica:
    "adequação da instalação elétrica interna da unidade, com remanejamento de pontos e revisão de circuitos",
  gas:
    "adequação da instalação predial de gás da unidade, com remanejamento de tubulação e de pontos de consumo e ensaio de estanqueidade",
};

/** O parágrafo pronto para o CreaNet. Vazio quando nenhum item do escopo
 *  entra na ART (só `nenhum`, por exemplo). */
export function descricaoTecnica(escopo: readonly string[]): string {
  const partes = escopo.filter((e) => FRASES[e]).map((e) => FRASES[e]);
  if (!partes.length) return "";
  const lista =
    partes.length === 1
      ? partes[0]
      : `${partes.slice(0, -1).join("; ")}; e ${partes[partes.length - 1]}`;
  return (
    `Reforma interna de unidade residencial compreendendo ${lista}. ` +
    "Execução conforme ABNT NBR 16280, sem alteração de elementos estruturais, " +
    "de fachada ou de áreas comuns da edificação."
  );
}
